/**
 *
 * @param arrayIn
 * @returns {string}
 */
const arrayToRange = (arrayIn = []) => {
  const rangeStruct = constructRanger(arrayIn);
  const resultArr = [];
  for (let i = 0; i < rangeStruct.length; i++) {
    resultArr.push(rangeStruct[i].toString());
  }

  return resultArr.join(', ');
};

function isNext(nextValue, currentValue) {
  return nextValue === currentValue + 1;
}

function getLast(arr) {
  return arr[arr.length - 1];
}

function rangeNodeToString(node) {
  let result = String(node.value);
  if (node.nextSet.length > 1) {
    result += ` - ${getLast(node.nextSet)}`;
  } else if (node.nextSet.length === 1) {
    result += `, ${node.nextSet[0]}`;
  }

  return result;
}

// This is a node to keep track of items that are ranges
function RangerNode(value) {
  const self = {
    value,
    nextSet: [],
    push: (input) => self.nextSet.push(Number(input)),
    toString: () => rangeNodeToString(self),
  };

  return self;
}

function sortArray(arrayIn = []) {
  return arrayIn.sort((a, b) => a - b);
}

function constructRanger(arrayIn) {
  const nodes = [];

  // Iterate over each item
  for (let i = 0; i < arrayIn.length; i++) {
    // Get the next value in the sequence as a number
    const nextValue = Number(arrayIn[i]);

    // Find next placement
    if (nodes.length) {
      const lastRangeNode = getLast(nodes);
      const currentValue = lastRangeNode.value;
      const lastValue = getLast(lastRangeNode.nextSet);

      if (lastValue && isNext(nextValue, lastValue)) {
        lastRangeNode.push(arrayIn[i]);
      } else if (isNext(nextValue, currentValue)) {
        lastRangeNode.push(nextValue);
      } else {
        nodes.push(RangerNode(nextValue));
      }
    } else {
      nodes.push(RangerNode(nextValue));
    }
  }

  return nodes;
}

function arrayToRangeWithSort(arrayIn) {
  return arrayToRange(sortArray(arrayIn));
}

export {arrayToRange, arrayToRangeWithSort};

export default arrayToRange;
